import { createActions, } from 'redux-actions';

export default createActions({
  DEAL_NOW: {
    REQUEST: null,
  },
});
